import { MenuItem, TextField, TextFieldProps } from '@mui/material'
import { CSSProperties, ReactElement } from 'react'
import styled from 'styled-components'

type valueType = string | number | (string | number)[]

export type TSelectMui = Omit<TextFieldProps, 'children'> & {
  items: {
    value: string | number
    label: string | ReactElement
  }[]
  textAlign?: CSSProperties['textAlign']
  value?: valueType
  onChange?: (value: any) => void
  multiple?: boolean
  renderValue?: (selected: valueType) => valueType
  fontSize?: number
}

export default function SelectMui({
  onChange,
  value,
  items,
  textAlign = 'left',
  multiple = false,
  renderValue,
  fontSize,
  ...props
}: Readonly<TSelectMui>) {
  return (
    <Column style={{ flex: 1 }}>
      <TextField
        sx={{
          '& .MuiInputBase-root': {
            backgroundColor: 'white',
            fontSize: fontSize ?? 'auto',
          },
          '& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': {
            color: '#b9b9b9ff',
          },
          '& .MuiInputLabel-root.Mui-focused': {
            color: '#092CA7',
            fontWeight: 300,
          },
        }}
        select
        onChange={(e) => {
          const val = e.target.value
          onChange?.(val)
        }}
        value={value ?? ''}
        style={{ display: 'flex', flex: 1, textAlign }}
        inputProps={{
          input: {
            style: {
              display: 'flex',
              flex: 1,
              textAlign,
              backgroundColor: 'white',
            },
          },
          select: {
            multiple,
            ...(renderValue && { renderValue: (selected: valueType) => renderValue(selected) }),
          },
        }}
        {...props}
      >
        {items.map((item) => (
          <MenuItem
            key={item.value}
            value={item.value}
            sx={{
              '&:hover': {
                backgroundColor: '#0f35b430',
              },
              '&.Mui-selected': { backgroundColor: '#0a30af', color: 'white' },
              '&.Mui-selected:hover': { backgroundColor: '#0f35b430', color: '#000000DE' },
            }}
          >
            {item.label}
          </MenuItem>
        ))}
      </TextField>
    </Column>
  )
}

const Column = styled.div`
  display: flex;
  flex-direction: column;
`
